import { render } from "./App.vue?vue&type=template&id=54be872d&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=54be872d&lang=scss"

import exportComponent from "C:\\Users\\DESARROLLADOR\\Downloads\\PRO001_FRONTEND_ADMIN_VE_160924\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__